export const DEFAULT_404_MESSAGE = "Hmm...we can't seem to find that.";

export const DEFAULT_UNAUTHORIZED_MESSAGE =
  'You are not authorized to view the';

export const DEFAULT_FORBIDDEN_MESSAGE =
  'You do not have permissions to view the';

export const DEFAULT_SERVER_ERROR_MESSAGE =
  'Oops! Something went wrong. Please try refreshing the page or contacting support.';
